import React from 'react';

// Visible build id so the field tech can confirm which build the phone is running.
export const APP_VERSION = process.env.REACT_APP_APP_VERSION || 'dev';

const AppVersion = () => (
  <p data-testid="app-version" className="text-center text-[10px] text-gray-400 py-2 select-all">
    Powered by Boatman Systems™ · v{APP_VERSION}
  </p>
);

export default AppVersion;
